import { Component, OnInit, OnChanges, Input, Output, EventEmitter, ElementRef, TemplateRef } from '@angular/core';
import { ILabel } from '../ILabel.model';
import { ActivatedRoute } from '@angular/router';
import { MultiListBoxItem, MultiListBoxItemState } from '../cpq-multi-list-box-with-selection/multi-list-box-item.model';
import { removeIfExists } from '../common/functions/js-linq';
import { GroupTemplateContext } from './cpq-multi-checkbox-with-selection.models';

@Component({
    selector: 'cpq-multi-checkbox-with-selection',
    templateUrl: './cpq-multi-checkbox-with-selection.component.html',
    styleUrls: ['./cpq-multi-checkbox-with-selection.component.scss'],
    standalone: false
})
export class CpqMultiCheckboxWithSelectionComponent implements OnInit, OnChanges {
  @Input('groupCustomTemplate') groupCustomTemplate: TemplateRef<GroupTemplateContext>;
  @Input('childCustomTemplate') childCustomTemplate: TemplateRef<GroupTemplateContext>;

  @Input('hasCustomTemplate') hasCustomTemplateFunc: Function;
  @Input('labelAvailable') labelAvailable: ILabel;
  @Input('labelLink') labelLink?: ILabel;
  @Input('items') groups: Array<MultiListBoxItem>;
  @Input('selectedItems') selectedItems: Array<MultiListBoxItem>;
  @Input('isReadOnly') isReadOnly: boolean;
  @Output('onSelect') onSelect: EventEmitter<MultiListBoxItem> = new EventEmitter<MultiListBoxItem>();
  @Output('onRemove') onRemove: EventEmitter<MultiListBoxItem> = new EventEmitter<MultiListBoxItem>();
  @Output('linkAction') linkAction?: EventEmitter<any> = new EventEmitter<any>();
  public MultiListBoxItemState =  MultiListBoxItemState;
  public allGroupsCheckboxState = MultiListBoxItemState.None;
  public lastSelectedIndex: number = 1;
  public isShiftKeyUsedForPreviousSelection: boolean = false;
  public isCtrlKeyUsedForPreviousSelection: boolean = false;
  @Output() selectedItemsChange = new EventEmitter<Array<MultiListBoxItem>>();

  public searchKeyword: string;
  public hasSearchResults = true;
  public get isShowOnlySelectedDisabled() {
    let notAnyChildSelected = true;
    if (this.groups && this.groups.length) {
      this.groups.forEach(group => {
        notAnyChildSelected = notAnyChildSelected && group.selectedAllChildrenState === MultiListBoxItemState.None;
      });
    }

    if (notAnyChildSelected && this.showOnlySelected) {
      this.showOnlySelected = false;
    }

    return notAnyChildSelected;
  };

  public allItems: Array<MultiListBoxItem> = new Array<MultiListBoxItem>();

  //#region SHOW ONLT SELECTED CB
  private _showOnlySelected = false;
  public get showOnlySelected() {
    return this._showOnlySelected;
  }
  public set showOnlySelected(value: boolean) {
    this._showOnlySelected = value;
    this.refresh();
    if (value) {
      this.iterateAllItems(x => x.isCollapsed = x.children && (!x.children.some(y => y.isVisible) || x.isDisabled));
    }
    else {
      this.colapseAllGroups();
    }
  }
  //#endregion

  constructor(public route: ActivatedRoute
  ) { }

  ngOnInit() {
  }

  ngOnChanges(changes) {
    document.getSelection().removeAllRanges();
    this.init();
  }

  private init() {
    this.iterateAllItems(null,
      (child: MultiListBoxItem, group: MultiListBoxItem) => {
        child.parentId = group.id;
        child.isVisible = true;
        child.isSelected = false;
        this.allItems.push(child);
      });
    this.setSelectedItems();
    this.refresh();
  }

  private setSelectedItems() {
    this.selectedItems.forEach(selectedItem => {
      this.groups.filter(group => group.children).forEach(group => {
        const child = group.children.find(child => child.id === selectedItem.id && child.parentId === selectedItem.parentId);
        if (child) {
          child.isSelected = true;
        }
      })
    });
  }

  private refresh() {
    this.refreshVisibility();
    this.refreshGroupsSelectAllCbState();
    this.setAllGroupsCheckboxState();
  }

  public onLinkClick(event) {
    this.linkAction.emit([event]);
  }

  //#region SELECT/DESELECT CHILD
  public toggleSelectedChildren(children, event: MouseEvent) {
    children.isSelected ? this.deselectChild(children) : this.selectChild(children, event);
    this.refresh();
  }

  public selectChild(children, event: MouseEvent) {
    document.getSelection().removeAllRanges();

    if (event.shiftKey) {
      this.selectRange(children);
    }
    else if (event.ctrlKey) {
      this.selectSingleItemByHoldingCtrl(children);
    }
    else {
      this.selectSingleItem(children);
    }
    this.onSelect.emit(children);
    this.selectedItemsChange.emit(this.selectedItems);
  }

  selectRange(selectedItem) {
    this.isShiftKeyUsedForPreviousSelection = true;

    this.groups.filter(group => group.children && group.children.find(child => child.id === selectedItem.id && child.parentId === selectedItem.parentId)).forEach(group => {
      if (this.lastSelectedIndex < group.children.indexOf(selectedItem)) {
        group.children.filter(item => group.children.indexOf(item) >= this.lastSelectedIndex && group.children.indexOf(item) <= group.children.indexOf(selectedItem)).forEach(filteredItem => {
          filteredItem.isSelected = true;
          this.selectedItems.push(filteredItem);
        });
      }
      else {
        group.children.filter(item => group.children.indexOf(item) >= group.children.indexOf(selectedItem) && group.children.indexOf(item) <= this.lastSelectedIndex).forEach(filteredItem => {
          filteredItem.isSelected = true;
          this.selectedItems.push(filteredItem);
        });
      }
    });

  }

  selectSingleItemByHoldingCtrl(selectedItem) {
    this.isCtrlKeyUsedForPreviousSelection = true;

    selectedItem.isSelected = !selectedItem.isSelected;
    this.groups.filter(group => group.children).forEach(group => {
      const child = group.children.find(child => child.id === selectedItem.id && child.parentId === selectedItem.parentId);
      if (child) {
        this.lastSelectedIndex = group.children.indexOf(selectedItem);
      }
      group.children.filter(item => item.isSelected).forEach(filteredItem => this.selectedItems.push(filteredItem));
    });

  }

  selectSingleItem(selectedItem) {
    if (this.isShiftKeyUsedForPreviousSelection || this.isCtrlKeyUsedForPreviousSelection) {
      this.deselectAll();
    }

    selectedItem.isSelected = !selectedItem.isSelected;
    this.groups.filter(group => group.children).forEach(group => {
      const child = group.children.find(child => child.id === selectedItem.id && child.parentId === selectedItem.parentId);
      if (child) {
        this.lastSelectedIndex = group.children.indexOf(selectedItem);
      }
    });
    if (this.selectedItems) {
      this.selectedItems.push(selectedItem);
    }
  }

  deselectAll() {
    this.groups.filter(item => item.isSelected).forEach(filteredItem => {
      filteredItem.isSelected = false;
      this.onSelect.emit(filteredItem)
    });

    this.isShiftKeyUsedForPreviousSelection = false;
    this.isCtrlKeyUsedForPreviousSelection = false;
    this.selectedItems = new Array<MultiListBoxItem>();
  }

  public deselectChild(children) {
    children.isSelected = false;
    if (this.selectedItems) {
      removeIfExists(this.selectedItems, x => x.id === children.id);
    }
    this.onRemove.emit(children);
  }
  //#endregion

  //#region SELECT ALL CB ON GROUPS
  public toggleGroupSelectAllCb(group, event: MouseEvent) {
    let currentState = group.selectedAllChildrenState;
    if (!currentState || currentState == MultiListBoxItemState.None || currentState == MultiListBoxItemState.Indeterminate) { // Any state besides 'all' changes state to 'all'

      group.children.forEach(child => {
        if (!child.isSelected) {
          this.selectChild(child, event);
        }
      });
    }
    else if (currentState == MultiListBoxItemState.All) { // 'all' state changes to 'none'
      group.children.forEach(child => {
        this.deselectChild(child);
      });
    }
    this.refresh();
  }

  public setAllGroupsCheckboxState() {
    let allGroupStates = [];
    this.groups.forEach(group =>
      allGroupStates.push(group.selectedAllChildrenState));

      if (allGroupStates.filter(groupState => groupState === MultiListBoxItemState.All).length === allGroupStates.length) {
        this.allGroupsCheckboxState = MultiListBoxItemState.All;
        return;
      }
      if (allGroupStates.filter(groupState => groupState === MultiListBoxItemState.All || groupState === MultiListBoxItemState.Indeterminate ).length > 0) {
        this.allGroupsCheckboxState = MultiListBoxItemState.Indeterminate;
        return;
      }

      this.allGroupsCheckboxState = MultiListBoxItemState.None;
  }

  public toggleSelectAllCb(checked: boolean, event: MouseEvent) {
    if (checked) {
      this.groups.forEach(group =>
        group.children.forEach(child => {
          if (!child.isSelected) {
            this.selectChild(child, event);
          }
        }));
    } else {
      this.groups.forEach(group =>
        group.children.forEach(child => {
          if (child.isSelected) {
            this.deselectChild(child);
          }
        }));
    }
    this.refresh();
  }

  private refreshGroupsSelectAllCbState() {
    this.iterateAllItems((group) => this.refreshGroupSelectAllCbState(group), null);
    this.setAllGroupsCheckboxState();
  }

  private refreshGroupSelectAllCbState(group: MultiListBoxItem) {
    if (group.children) {
      let numberOfSelectedChildren = group.children ? group.children.filter(x => x.isSelected).length : 0;
      if (numberOfSelectedChildren === group.children.length && group.children.length > 0) {
        group.selectedAllChildrenState = MultiListBoxItemState.All;
      } else if (numberOfSelectedChildren > 0) {
        group.selectedAllChildrenState = MultiListBoxItemState.Indeterminate;
      } else {
        group.selectedAllChildrenState = MultiListBoxItemState.None;
      }
    }
    this.selectedItemsChange.emit(this.selectedItems);
  }

  public colapse(item: MultiListBoxItem) {
    item.isDisabled ? item.isCollapsed = true : item.isCollapsed = !item.isCollapsed;
  }
  //#endregion

  //#region VISIBILITY AND SEARCH
  public search() {
    this.refreshVisibility();
    if (!this.searchKeyword) {
      this.colapseAllGroups();
    }
  }

  public clearSearchInput() {
    this.searchKeyword = "";
    this.search();
  }

  public refreshVisibility() {
    this.iterateAllItems(
      (g) => g.isVisible = !this.showOnlySelected || (g.children && (g.children.some(x => x.isSelected) || g.isDisabled)),
      (c) => c.isVisible = !this.showOnlySelected || c.isSelected);
    // search
    if (this.searchKeyword) {
      this.iterateAllItems((group) => {
        const hasSelectedChildren = group.children && group.children.some(x => x.isVisible);
        group.isVisible = hasSelectedChildren;
        group.isCollapsed = !hasSelectedChildren;
      },
        (child, group) => {
          // only for items who are currently visible, leave it visible only if their name contains searchKeyword
          child.isVisible = child.isVisible && child.name.toLowerCase().indexOf(this.searchKeyword.toLocaleLowerCase()) > -1;
          if (!group.isVisible && child.isVisible) {
            group.isVisible = true;
          }
        }
      )
      this.hasSearchResults = this.allItems.some(x => x.isVisible);
    }
    else {
      this.hasSearchResults = true;
    }
  }

  public colapseAllGroups() {
    this.iterateAllItems(g => g.isCollapsed = true, null);
  }

  public shouldRenderCustomTemplate(item: MultiListBoxItem) {
    return this.childCustomTemplate && (!this.hasCustomTemplateFunc || this.hasCustomTemplateFunc(item));
  }
  //#endregion

  //#region HELPERS
  private iterateAllItems(groupCallback: Function, groupChildCallback: Function = null) {
    if (this.groups && (groupCallback || groupChildCallback)) {

      this.groups.forEach(group => {

        if (groupChildCallback && group.children) {
          group.children.forEach(child => {
            groupChildCallback(child, group);
          });
        }

        if (groupCallback) {
          groupCallback(group);
        }

      });
    }
  }
  //#endregion
}
